import ConfirmActionPopup from 'components/ConfirmActionPopup';
import StyledActionButton from 'components/layout/StyledActionButton';
import React, {Component, ReactNode} from 'react';
import {Icon, Popup} from 'semantic-ui-react';


const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

interface Props {
  disabled?: boolean,
  popupMessage?: string,
  renderContent?: () => ReactNode,
  hoverMessage: string,
  trigger?: React.ReactNode,
  poperDependencies?: any[],
  onConfirm: () => void,
  onOpen?: () => void
}

interface State {

}

class TestResultActionButton extends Component<Props, State> {

  defaultTrigger = <Icon name={'flask'}/>;

  render(): React.ReactNode {
    const {
      disabled = false,
      hoverMessage,
      popupMessage,
      renderContent,
      poperDependencies,
      onOpen,
      onConfirm,
      trigger = this.defaultTrigger
    } = this.props;

    if (popupMessage || renderContent) {
      return (
          <ConfirmActionPopup
              message={popupMessage}
              renderContent={renderContent}
              renderTarget={this.renderButton()}
              poperDependencies={poperDependencies}
              onConfirmAction={onConfirm}
              onOpen={onOpen}
              disabled={disabled}
              position="left center"
          />
      );
    }
    return (
        <StyledActionButton icon
                            disabled={disabled}
                            type='button'
                            onClick={onConfirm}
        >
          <Popup
              trigger={trigger}
              content={hoverMessage}
              size='small'
              position='top center'
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    );

  }

  renderButton = (): React.ReactNode => {
    const {disabled = false, hoverMessage, trigger = this.defaultTrigger} = this.props;

    return (
        <StyledActionButton icon
                            disabled={disabled}
                            type='button'
        >
          <Popup
              trigger={trigger}
              content={hoverMessage}
              size='small'
              position='top center'
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    );
  };

}

export default TestResultActionButton;
